import src from "IMAGE";
export default { src, width: 279, height: 86, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AIFAPojXdHHjsF5cup5LSaadSkimrFdVtbddW8FzOTd5ACgTEyl6Pj2BllJUqHFHUpZxRlGVdEtWlZ9ZWaw4Ghk6vZ0a6wSdpX8AAAAASUVORK5CYII="};
